export {default} from './DetailsCard.container'
